import React, { useState } from 'react';

const InvoiceTable = () => {
  const styles = `
    .invoice-container {
      padding: 20px;
      font-family: Arial, sans-serif;
      background-color: #f5f5f5;
    }

    .invoice-table {
      width: 100%;
      border-collapse: collapse;
      background-color:white;;
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      border-radius: 8px;
      overflow: hidden;
    }

    .table-header th {
      background-color: #f8f9fa;
      padding: 12px 15px;
      text-align: left;
      font-weight: 600;
      color: #333;
      border-bottom: 2px solid #e9ecef;
    }

    .section-header td {
      padding: 0;
      border: none;
    }

    .section-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 15px;
      background-color: #f1f3f4;
      font-weight: 600;
      color: #444;
      border-top: 1px solid #e0e0e0;
    }

    .data-row td {
      padding: 8px 15px;
      border-bottom: 1px solid #e9ecef;
      vertical-align: middle;
    }

    .data-row:nth-child(even) {
      background-color: #f8f9fa;
    }

    .data-row:hover {
      background-color: #f1f3f4;
    }

    .description-cell {
      width: 40%;
    }

    .amount-cell {
      width: 15%;
      text-align: right;
    }

    .action-cell {
      width: 5%;
      text-align: center;
    }

    .description-input {
      width: 100%;
      padding: 6px 8px;
      border: 1px solid #ddd;
      border-radius: 4px;
      font-size: 14px;
      background-color:white;;
    }

    .description-input:focus {
      outline: none;
      border-color: #007bff;
      box-shadow: 0 0 0 2px rgba(0,123,255,0.25);
    }

    .amount-input {
      width: 80px;
      padding: 6px 8px;
      border: 1px solid #ddd;
      border-radius: 4px;
      font-size: 14px;
      text-align: right;
      background-color:white;;
    }

    .amount-input:focus {
      outline: none;
      border-color: #007bff;
      box-shadow: 0 0 0 2px rgba(0,123,255,0.25);
    }

    .add-btn {
      background-color: #28a745;
      color:white;;
      border: none;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      cursor: pointer;
      font-size: 18px;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease;
    }

    .add-btn:hover {
      background-color: #218838;
      transform: scale(1.1);
    }

    .remove-btn {
      background-color: #dc3545;
      color:white;;
      border: none;
      width: 25px;
      height: 25px;
      border-radius: 50%;
      cursor: pointer;
      font-size: 16px;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease;
    }

    .remove-btn:hover {
      background-color: #c82333;
      transform: scale(1.1);
    }

    .remove-btn:active, .add-btn:active {
      transform: scale(0.95);
    }
  `;

  // Inject styles
  React.useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = styles;
    document.head.appendChild(styleSheet);
    return () => document.head.removeChild(styleSheet);
  }, []);
  const [legalCostRows, setLegalCostRows] = useState([
    { id: 1, description: 'Legal Fees', net: '650.00', vat: '£130.00', gross: '£780.00', isFixed: false },
    { id: 2, description: 'Telegraphic Transfer (TT) Fee', net: '30.00', vat: '£6.00', gross: '£36.00', isFixed: false },
    { id: 3, description: 'Identity Check', net: '40.00', vat: '£0.00', gross: '£40.00', isFixed: false },
    { id: 4, description: '', net: '', vat: '£0.00', gross: '£0.00', isFixed: false }
  ]);

  const [disbursementRows, setDisbursementRows] = useState([
    { id: 1, description: 'Official Copies', net: '£14.00', vat: '£0.00', gross: '£14.00', isFixed: false }
  ]);

  const addRow = (section) => {
    const newRow = {
      id: Date.now(),
      description: '',
      net: '',
      vat: '£0.00',
      gross: '£0.00',
      isFixed: false
    };

    if (section === 'legalCost') {
      setLegalCostRows([...legalCostRows, newRow]);
    } else if (section === 'disbursements') {
      setDisbursementRows([...disbursementRows, newRow]);
    }
  };

  const removeRow = (section, id) => {
    if (section === 'legalCost') {
      setLegalCostRows(legalCostRows.filter(row => row.id !== id));
    } else if (section === 'disbursements') {
      setDisbursementRows(disbursementRows.filter(row => row.id !== id));
    }
  };

  const updateRow = (section, id, field, value) => {
    const updateRows = (rows) => rows.map(row =>
      row.id === id ? { ...row, [field]: value } : row
    );

    if (section === 'legalCost') {
      setLegalCostRows(updateRows(legalCostRows));
    } else if (section === 'disbursements') {
      setDisbursementRows(updateRows(disbursementRows));
    }
  };

  const renderRow = (row, section, isHeader = false) => (
    <tr key={row.id} className={isHeader ? 'header-row' : 'data-row'}>
      <td className="description-cell">
        {row.isFixed ? (
          <span>{row.description}</span>
        ) : (
          <input
            type="text"
            value={row.description}
            onChange={(e) => updateRow(section, row.id, 'description', e.target.value)}
            className="description-input"
            placeholder="Enter description"
          />
        )}
      </td>
      <td className="amount-cell">
        {row.isFixed ? (
          <span>{row.net}</span>
        ) : (
          <input
            type="text"
            value={row.net}
            onChange={(e) => updateRow(section, row.id, 'net', e.target.value)}
            className="amount-input"
            placeholder="0.00"
          />
        )}
      </td>
      <td className="amount-cell">
        <span>{row.vat}</span>
      </td>
      <td className="amount-cell">
        <span>{row.gross}</span>
      </td>
      <td className="action-cell">
        {!row.isFixed && (
          <button
            className="remove-btn"
            onClick={() => removeRow(section, row.id)}
            title="Remove row"
          >
            ×
          </button>
        )}
      </td>
    </tr>
  );

  const renderSection = (title, rows, section) => (
    <React.Fragment>
      <tr className="section-header">
        <td colSpan="5">
          <div className="section-title">
            <span>{title}</span>
            <button
              className="add-btn"
              onClick={() => addRow(section)}
              title="Add row"
            >
              +
            </button>
          </div>
        </td>
      </tr>
      {rows.map(row => renderRow(row, section))}
    </React.Fragment>
  );

  return (
    <div className="invoice-container">
      <table className="invoice-table">
        <thead>
          <tr className="table-header">
            <th>Description</th>
            <th>Net</th>
            <th>VAT</th>
            <th>Gross</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {renderSection('Legal Cost', legalCostRows, 'legalCost')}
          {renderSection('Disbursement - Third Party Expenditure', disbursementRows, 'disbursements')}
        </tbody>
      </table>
    </div>
  );
};

export default InvoiceTable;